import { Alert, AlertIcon, Box, Button, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { ErrorDetails } from '@texas/components/shared/alert/ErrorDetails';
import { useAvailableArticleRange } from './useAvailableArticleRange';

interface Props {
  mode: 'single' | 'range';
  itemCode: string;
  suggestedRange: ReturnType<typeof useAvailableArticleRange>;
  onApply: () => void;
}

export function ArticleRangeClash({
  mode,
  itemCode,
  suggestedRange,
  onApply,
}: Props) {
  const { t } = useTranslation();
  return (
    <Alert status="error" alignItems="flex-start">
      <AlertIcon />
      <Box>
        <Text>
          {t(
            mode === 'range'
              ? 'article.create.firstArticleClash'
              : 'article.create.singleArticleClash',
            { itemCode },
          )}
        </Text>
        {mode === 'range' && (
          <Box mt={3} aria-live="polite">
            {suggestedRange.loading ? (
              <Text>{t('article.create.findingRange')}</Text>
            ) : suggestedRange.error ? (
              <ErrorDetails error={suggestedRange.error} />
            ) : suggestedRange.data ? (
              <>
                <Text>
                  {t('article.create.suggestedRange', {
                    first: suggestedRange.data.firstItemCode,
                    last: suggestedRange.data.lastItemCode,
                  })}
                </Text>
                <Button mt={2} variant="texas-solid" onClick={onApply}>
                  {t('article.create.useSuggestedRange')}
                </Button>
              </>
            ) : (
              <Text>{t('article.create.noAvailableRange')}</Text>
            )}
          </Box>
        )}
      </Box>
    </Alert>
  );
}
